import React from 'react';
import PropTypes from 'prop-types';
import { Field } from "formik";
import FormikNewTextField from './FormikNewTextField.jsx';
import useFormikSchema from '../hooks/useFormikSchema';

// made custom wrapper because formik-material-ui does not respect accessibility attributes
// import { TextField } from "formik-material-ui";


const FormikTextField = props => {
  const { disabled, value, name, label, fieldProps, schema, ...rest } = props;
  const dataTestId = props['data-testid'];
  const { formattedLabel } = useFormikSchema(name, label, schema);
  return (
    <Field
      fullWidth
      disabled={disabled}
      value={value}
      variant={'outlined'}
      name={name}
      label={formattedLabel}
      data-testid={dataTestId}
      {...rest}
      { ...fieldProps }
      component={FormikNewTextField}/>
  );
};

FormikTextField.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  fieldProps: PropTypes.object,
};

FormikTextField.defaultProps = {
  fieldProps: {}
};

export default FormikTextField;
